"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const AdvanceFilter_1 = require("./AdvanceFilter");
const Button_1 = __importDefault(require("components/design-system/Button"));
const ResetFilterButton = () => {
    const { id, defaultFilter } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const setFilter = (0, useFilter_1.default)(state => state.setFilter);
    const handleResetFilter = () => {
        setFilter(id, defaultFilter);
    };
    return (react_1.default.createElement(Button_1.default.Tertiary, { onClick: handleResetFilter }, "Reset Filters"));
};
exports.default = react_1.default.memo(ResetFilterButton);
